import { Injectable } from '@angular/core';
import { ResponseCommonSI } from '@interfaces/services/common.interfaces';
import { firstValueFrom } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { BASE_URL, ENDPOINTS } from '@core/config/constants';
import {
  CheckLoadMassive,
  createPolicyDataSI,
  getPoliceDataIS,
} from '@views/interfaces/services/policyData.interface';
import { FileInterface } from '@views/interfaces/file.interface';

@Injectable({
  providedIn: 'root',
})
export class FlowService {
  constructor(private http: HttpClient) {}

  async postMassiveLoad(body: FileInterface): Promise<void> {
    const result = await firstValueFrom<ResponseCommonSI<void>>(
      this.http.post(`${BASE_URL}${ENDPOINTS.POLICY_MASSIVE_LOAD}`, body)
    );
    return result.payload;
  }

  async checkLoadMassive(): Promise<CheckLoadMassive> {
    const result = await firstValueFrom<ResponseCommonSI<CheckLoadMassive>>(
      this.http.get(`${BASE_URL}${ENDPOINTS.POLICY_MASSIVE_LOAD_CHECK}`, {params: {spinner: false}})
    );
    return result.payload;
  }

  async getPolicyData(idPolicyData: string): Promise<getPoliceDataIS> {
    const result = await firstValueFrom<ResponseCommonSI<getPoliceDataIS>>(
      this.http.get(`${BASE_URL}${ENDPOINTS.SAVED_POLICY_DATA}/${idPolicyData}`)
    );
    return result.payload;
  }

  async policyData(
    body: createPolicyDataSI
  ): Promise<{ idPolicyData: string }> {
    const result = await firstValueFrom<
      ResponseCommonSI<{ idPolicyData: string }>
    >(this.http.post(`${BASE_URL}${ENDPOINTS.SAVED_POLICY_DATA}`, body));
    return result.payload;
  }
}
